import { render } from "./ConsentReviewHarness.vue?vue&type=template&id=881e7cb0&scoped=true"
import script from "./ConsentReviewHarness.vue?vue&type=script&lang=js"
export * from "./ConsentReviewHarness.vue?vue&type=script&lang=js"

import "./ConsentReviewHarness.vue?vue&type=style&index=0&id=881e7cb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881e7cb0"]])

export default __exports__